<template>
  <div id="app">
    <!-- this wraps a custom stepper graphic and the steps together -->
    <multi-stage-form
      :current-step="currentStep"
      :style="{maxWidth: '500px', margin: '0 auto'}"
      @stepsCounted="(num) => numOfSteps = num"
    >
      <!-- the stepper goes in the stepper slot -->
      <template v-slot:stepper>
        <!--   <other-stepper
          :current-step="currentStep"
          @stepTo="moveToStep"
        /> -->
        <custom-stepper
          class="custom-stepper"
          color="green"
          max-width="1000px"
          :current-step="currentStep"
          @stepTo="moveToStep"
        >
          <font-awesome-icon
            icon="check"
          />
        </custom-stepper>
      </template>
      <!-- the steps can be any element/component,
      include a title attribute if you want automatic header and stepper label -->
      <StepContact
        :value="form.contact"
        :title="$t('business_listing.stepper.contact')"
        step-class="form-section"
        :is-outer-step="isFirstOrLastStep"
        @next="next"
        @prev="prev"
      />
      <StepBusiness
        :value="form.business"
        :title="$t('business_listing.stepper.business')"
        step-class="form-section"
        :is-outer-step="isFirstOrLastStep"
        @next="next"
        @prev="prev"
      />
      <StepPayment
        :value="form.payment"
        :title="$t('business_listing.stepper.payment')"
        step-class="form-section"
        :is-outer-step="isFirstOrLastStep"
        @next="next"
        @prev="prev"
      />
      <StepImages
        :value="form.images"
        :title="$t('business_listing.stepper.images')"
        step-class="form-section"
        :is-outer-step="isFirstOrLastStep"
        @next="next"
        @prev="prev"
      />
      <StepAddress
        :value="form.address"
        :title="$t('business_listing.stepper.address')"
        step-class="form-section"
        :is-outer-step="isFirstOrLastStep"
        @next="next"
        @prev="prev"
      />
      <StepHours
        :value="form.days"
        :title="$t('business_listing.stepper.hours')"
        step-class="form-section"
        :is-outer-step="isFirstOrLastStep"
        @next="next"
        @prev="prev"
      />
    </multi-stage-form>
  </div>
</template>

<script>
import StepImages from '../components/BusinessDetails/StepImages'
import StepBusiness from '../components/BusinessDetails/StepBusiness'
import StepContact from '../components/BusinessDetails/StepContact'
import StepPayment from '../components/BusinessDetails/StepPayment'
import StepAddress from '../components/BusinessDetails/StepAddress'
import StepHours from '../components/BusinessDetails/StepHours'
// import OtherStepper from '../components/OtherStepper'
import CustomStepper from '../components/CustomStepper'
import MultiStageForm from '../components/MultiStageForm'

const typicalDay = {
  open: { HH: '09', mm: '00' },
  close: { HH: '17', mm: '30' },
  isOpenToday: true
}

export default {

  name: 'TestWizardForm',

  components: {
    StepImages,
    StepBusiness,
    StepContact,
    StepPayment,
    StepAddress,
    StepHours,
    CustomStepper,
    MultiStageForm
    // OtherStepper
  },

  data () {
    return {
      currentStep: 0,
      numOfSteps: 0,
      stepProgress: [],
      form: {
        contact: {
          phoneNumber: '',
          email: '',
          webUrl: '',
          facebook: '',
          linkedIn: '',
          twitter: ''
        },
        business: {
          accountName: '',
          businessName: '',
          businessDescription: '',
          category: ''
        },
        payment: {
          keywords: [],
          paymentMethods: []
        },
        images: {
          files: [],
          logo: []
        },
        address: {
          addressLine1: '',
          addressLine2: '',
          addressLine3: '',
          town: '',
          county: '',
          postcode: '',
          hideAddress: false
        },
        days: {
          mon: { ...typicalDay },
          tue: { ...typicalDay },
          wed: { ...typicalDay },
          thu: { ...typicalDay },
          fri: { ...typicalDay },
          sat: { ...typicalDay, isOpenToday: false },
          sun: { ...typicalDay, isOpenToday: false }
        }
      }
    }
  },
  computed: {
    isFirstOrLastStep () {
      return {
        first: this.currentStep === 0,
        last: this.currentStep === this.numOfSteps
      }
    }
  },
  methods: {
    moveToStep (step) {
      // if (this.stepProgress[step - 1] || step === 0) {
      this.currentStep = step
      // }
    },

    next ($v) {
      $v.$touch()
      if ($v.$invalid) {
        // do nothing yet
      } else {
        $v.$reset()
        this.stepProgress[this.currentStep] = true
        this.currentStep++
      }
    },
    prev () {
      this.currentStep--
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '../../sass/_variables.scss';

  .black {
    color:black;
  }

  article {
    max-width: 500px;
    margin: auto;
  }

  .custom-stepper {
    margin-bottom: 25px;
    margin-top: 20px;
  }

</style>

<style lang="scss">
.form-section {
  padding: 20px 15px;
  background-color: var(--form-color-light);

  color:black;
  margin: 5px auto;

  &.form-instruction {
    font-size: 1.2em;
  }

  &.dark {
    // background-color: $primary-blue;
    background-color: var(--primary-color);
    color: white;
  }
}

</style>

<style lang="scss">
@import '../../sass/_variables.scss';
  .time-picker-group {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;
    min-height: 35px;

    .time-picker-pair {
      display: flex;
      justify-content: center;
      align-items: center;
      position: relative;
      width: 300px;
      text-align: center;

      .time-picker {
        width: inherit;
        input.display-time {
          border-radius: 4px;
          text-align: center;
          width: 135px;
        }
        .dropdown {
          ul li.active {
            background-color: var(--sidebar-bg-color);
            &:hover {
              background-color: var(--sidebar-bg-color);
            }
          }
        }
      }
    }
  }

  @media only screen and (max-width: $break-small) {
    .time-picker-group {
      flex-direction: column;
      > div:first-child {
        align-self: baseline;
        margin: 5px 0;
      }
    }
  }
</style>

<style type="text/css">

  .shake {
    animation-duration: .4s;
    animation-iteration-count: 1;
    animation-name: shake !important;
    animation-timing-function: linear;
    transform-origin: 50% 50%;
  }
</style>
